function showBrands(evt, brandInitials) {
  var i, gbtabcontent, gbtablinks;
  gbtabcontent = document.getElementsByClassName("gibbys-tabcontent");
  for (i = 0; i < gbtabcontent.length; i++) {
    gbtabcontent[i].style.display = "none";
  }
  gbtablinks = document.getElementsByClassName("gibbys-tablinks");
  for (i = 0; i < gbtablinks.length; i++) {
    gbtablinks[i].className = gbtablinks[i].className.replace(" gibbys-active", "");
  }
  document.getElementById(brandInitials).style.display = "block";
  evt.currentTarget.className += " gibbys-active";
}